module.exports = __webpack_public_path__ + "media/images/new_home/logo-green-89966598f5aaa7576b0109e7f5076890.png";